import { render } from "./SkeletonPackCatalogueItem.vue?vue&type=template&id=588dc3cb"
const script = {}

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__